<template>
  <div class="header">
    <header>
      <div v-if="addShow"
           @click="handle_icon"
           class="add">
        <img src="../assets/images/ask_btn.png">
      </div>
      <div class="back"
           v-if="returnShow"
           @click="goBack">
        <img src="../assets/images/return.png" />
      </div>
      <h3>{{title.name}}</h3>
      <div class="right"
           @click="parentHandler">
        <slot name="right-sum"></slot>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: Object
    },
    returnShow: {
      type: Boolean,
      default: true
    },
    addShow: {
      type: Boolean,
      default: false
    },
    goBackHandler: {
      type: Function
    }
  },
  data () {
    return {};
  },
  methods: {
    goBack () {
      if (this.goBackHandler) {
        this.goBackHandler();
        return;
      }
      if (
        this.$pub.filterAppPage(this.$route.name) &&
        this.$store.state.app &&
        !this.$store.state.back_normal && 
        this.$route.query.back == 1
      ) {
        this.$pub.appAction("closeAppPage");
        return;
      }
      if (this.$route.name == "Order" && this.$store.state.app) {
        // 题库开关 如果关闭 移动端个人中心tab下标调整为3 开启 调整为4
        if (this.$store.state.config.switch_question_module == 1) {
          this.$pub.appAction("homePage", { index: 4 });
        } else {
          this.$pub.appAction("homePage", { index: 3 });
        }
      }
      if (this.title.backUrl) {
        this.$router.replace({
          name: this.title.backUrl
        });
        return;
      }
      if (window.history.length <= 1 || this.title.share) {
        this.$router.push({
          path: "/"
        });
        return;
      }
      // 如果离开的页面是我的作业 则需要清除搜索条件
      // console.log(this.$route.name);
      if (this.$route.name == "Homework") {
        this.$store.commit("OTO_KEY");
      }
      this.$router.go(-1);
    },
    parentHandler () {
      this.$emit("toGet");
    },
    handle_icon () {
      this.$emit("addAsk");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  height: 88px;
  line-height: 88px;
  background: #fff;
  header {
    height: 88px;
    position: fixed;
    z-index: 999;
    width: 100%;
    background: #fff;
    .add {
      float: left;
      width: 90px;
      height: 46px;
      margin-top: 8px;
      margin-left: 29px;
      img {
        width: 100%;
      }
    }
    .back {
      float: left;
      width: 80px;
      text-align: center;
      img {
        widows: 18px;
        height: 32px;
      }
    }
    h3 {
      font-size: 36px;
      color: #595959;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 500px;
    }
    .right {
      height: 100%;
      float: right;
      font-size: 30px;
      color: #595959;
      padding: 0 20px;
    }
  }
}
</style>